/**
 * reportWebVitals
 *
 * Optional Core Web Vitals reporter. In v1 we don't send these anywhere;
 * function is wired up so the build picks up web-vitals and we can route
 * them to Sentry / a metrics endpoint later without touching index.js.
 */

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFID(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
